<template>
 <div>
    <div class="add-button c-float m-b-20 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1">
        <p class="user-name">{{ $t('item_catalog') }}</p>
      </div>
      <Dropdown
        class="flex drop-right"
        :buttonText="$t('add')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <DataTable
      :customTable=false
      :type="type"
      :dropdown=false
      :tableHeader=true
      :tableHead=true
      tableActions="ITEMS"
      tableAPI="ITEMS"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=true
      :count="get_items_count"
      :list="get_items_list"
      :rowActionParameter="rowActionParameter"
      :referenceData="referenceData"
      :filterOptions="filterOptions"
      :updateIterator="updateIterator"
      @updatedSelections="tableSelectionsUpdated"
      @actionOptionTriggered="actionOptionTriggered"
      @rowAction="rowAction" />
   <Popup
     v-if="openImport"
     :showConfirmButton="showImportButton && !get_error_message"
     :confirmText="$t('import')"
     @cancel="togglePopupEdit"
     @confirm="submitForm">
     <template v-slot:header>
       <h2>{{ $t('Import Template') }}</h2>
     </template>
     <UploadTemplate
       @enabeImport="enableImport"
       @disableImport="showImportButton = false"
       @closePopup="closePopupAndTrackImportProcess"
       @uploaded="updateTableAfterUpload"
       templateType="item_fields" />
     <message v-if="get_error_message.type" name="warning" :data="get_error_message"></message>
   </Popup>
 </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import Dropdown from '@/components/global/dropdown';
import Popup from '@/components/global/popup';
import DataTable from '@/components/table/index.vue';
import UploadTemplate from '@/components/global/uploadTemplate';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import formValidator from '@/mixins/formValidator';
import EventBus from '@/eventBus';

/* eslint-disable */
export default {
  name: 'Items',
  components: {
    DataTable,
    Dropdown,
    Popup,
    UploadTemplate,
    AddressPicker,
    InputText,
    PhoneSelect,
    InputSelect,
  },
  mixins: [mixin,formValidator],
  data() {
    return {
      updateIterator: 1,
      openImport: false,
      totalCount: 300,
      showImportButton: false,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('view_item')}`,
      },
      type: {
        type: false,
        image: true,
        data: 'image'
      },
      referenceData: [
        {
          name: `${this.$t('name')}`,
          sku_code: `${this.$t('sku_code')}`
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('create_item')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('import_item')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        }
      ],
      actionsOptions: [
        {
          text: `${this.$t('delete')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'get_items_list',
      'get_items_count',
      'get_filters_menu',
      'get_active_filter',
      'get_error_message',
      'get_import_queue',
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'items',
        tableApi: 'items/get-list',
        filterFields: {
          name: {
            label: `${this.$t('name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sku_code: {
            label: `${this.$t('sku_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          ean_number: {
            label: `${this.$t('ean_number')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          is_visible: {
            label: `${this.$t('is_visible')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          contains_dangerous_goods: {
            label: `${this.$t('dangerous_goods')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          contains_temp_controlled: {
            label: `${this.$t('temp_controlled')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
        },
        actionsOptions: [
          {
            text: `${this.$t('delete')}`,
            subText: `${this.$t('Delete selections')}`,
            icon: 'deleteForever',
          },
        ],
      }
    },
  },
  methods: {
    optionSelected(opt) {
      if (opt === 'dropOption1') {
        this.$router.push(`items/add-item`);
      }
      if (opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
    },
    rowAction(val) {
      this.$router.push(`items/${val}/edit-item`);
    },
    // Table actions
    updateTableAfterUpload() {
      this.updateIterator++;
    },
    tableSelectionsUpdated(val) {
      this.selectedItems = val.selectedList;
      this.isTableAllSelected = val.selectTotalRows;
    },
    actionOptionTriggered(option) {
      if (option.dropOption == 'dropOption1') {
        // Delete
        if (this.isTableAllSelected) {
          this.$store.dispatch('DELETE_ITEMS', {
            type: 'byFilter',
            search: this.$route.query.search,
            searchTerm: this.$route.query.searchTerm,
            count: this.get_items_count,
          }).then(() => {
            console.log('DELETE ITEMS byFilter')
            this.updateIterator++
          });
        } else {
          this.$store.dispatch('DELETE_ITEMS', {
            type: 'byId',
            id: 0,
            ids: option.list,
          }).then(() => {
            console.log('DELETE ITEMS byID')
            this.updateIterator++
          });
        }
      }
    },
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    enableImport() {
      this.showImportButton = true;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType == 'item_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })
      },
      deep: true
    }
  }
};
</script>
